module.exports = __webpack_public_path__ + "img/hirschberg.3d9e05e3.jpg";